import { useTranslation } from 'react-i18next';
import { ColumnsConfig } from '../IssuePreviewModal/ReportPreviewUtils';
import React from 'react';
import { ColumnType } from '../ReportPreviewModal/ReportPreviewUtils';

export const issueTrackerModalColumns: ColumnsConfig[] = [
	{
		fieldName: 'issueID',
		configurationLabel: 'label.dashboardRevamp.issueID',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'question',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.question',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'answer',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.response',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'category',
		configurationLabel: 'label.dashboardRevamp.category',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'siteName',
		configurationLabel: 'label.dashboardRevamp.site',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'issueOwner',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.issueOwner',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'priority',
		configurationLabel: 'label.dashboardRevamp.issueInsights.priority',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'severity',
		configurationLabel: 'label.dashboardRevamp.issueInsights.severity',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'dueOn',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.dueOn',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'timeSinceOpened',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.timeSinceOpened',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
	},
	{
		fieldName: 'status',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.statusHistory',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'lastUpdatedAt',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.lastUpdatedOn',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
	{
		fieldName: 'lastUpdatedBy',
		configurationLabel: 'label.dashboardRevamp.executiveDashboard.lastUpdatedBy',
		isSelected: true,
		rowClassName: 'aa-text-left aa-font-normal',
		type: ColumnType.Text,
	},
];

export const OpenElement = ({ time }: { time: string }) => {
	const { t } = useTranslation();
	return (
		<div>
			<span className="aa-font-sans aa-font-semibold aa-text-base">
				{t('label.dashboardRevamp.executiveDashboard.open')}
			</span>
			<br />
			<span className="aa-font-sans aa-text-sm">{time}</span>
		</div>
	);
};

export const InProgressElement = ({ time }: { time: string }) => {
	const { t } = useTranslation();
	return (
		<div>
			<span className="aa-font-sans aa-font-semibold aa-text-base">
				{t('label.dashboardRevamp.executiveDashboard.inProgress')}
			</span>
			<br />
			<span className="aa-font-sans aa-text-sm">{time}</span>
		</div>
	);
};

export const InReviewElement = ({ time }: { time: string }) => {
	const { t } = useTranslation();
	return (
		<div>
			<span className="aa-font-sans aa-font-semibold aa-text-base">
				{t('label.dashboardRevamp.executiveDashboard.inReview')}
			</span>
			<br />
			<span className="aa-font-sans aa-text-sm">{time}</span>
		</div>
	);
};

export const ResolvedElement = ({ time }: { time: string }) => {
	const { t } = useTranslation();
	return (
		<div>
			<span className="aa-font-sans aa-font-semibold aa-text-base">
				{t('label.dashboardRevamp.executiveDashboard.resolved')}
			</span>
			<br />
			<span className="aa-font-sans aa-text-sm">{time}</span>
		</div>
	);
};

export enum PAGE_TYPE {
	EXEC_PAGE = 'executiveDashboard',
	OPS_KPI = 'opsKpi',
	ISSUE_INSIGHTS = 'issueInsights',
	REPORT_INSIGHTS = 'reportInsights',
}
